/**
 * Shared right-hand drawer: cart, size guide, framing info, collection filters.
 *
 * Host must use class "drawer" (cart chrome). Open/close, overlay click,
 * Escape, focus trap, and body scroll lock live here so every surface stays
 * in lockstep when the pattern changes.
 */
class FabDrawer extends HTMLElement {
  constructor() {
    super();
    this.activeElement = null;
    this._onKeyUp = (evt) => {
      if (evt.code === 'Escape') this.close();
    };
    this.addEventListener('keyup', this._onKeyUp);
    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-drawer-close], .drawer__close, .product-drawer__close')) {
        event.preventDefault();
        this.close();
        return;
      }
      if (
        event.target === this ||
        event.target.matches('[data-drawer-overlay], .cart-drawer__overlay, .drawer__overlay, .product-drawer__overlay')
      ) {
        this.close();
      }
    });
  }

  connectedCallback() {
    if (this.hasAttribute('data-drawer-no-portal')) return;
    if (this._fabDrawerMoved) return;
    this._fabDrawerMoved = true;
    if (this.parentElement !== document.body) {
      document.body.appendChild(this);
    }
  }

  get trapContainer() {
    return this.querySelector('[role="dialog"]') || this.querySelector('.drawer__inner') || this;
  }

  get trapFocusEl() {
    return (
      this.querySelector('[data-drawer-initial-focus]') ||
      this.querySelector('.drawer__close') ||
      this.querySelector('.drawer__heading') ||
      this.trapContainer
    );
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const container = this.trapContainer;
        const focusEl = this.trapFocusEl;
        if (container && typeof trapFocus === 'function') {
          trapFocus(container, focusEl);
        } else if (focusEl && focusEl.focus) {
          focusEl.focus();
        }
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    }
    document.body.classList.remove('overflow-hidden');

    if (this.activeElement && typeof this.activeElement.focus === 'function') {
      try {
        this.activeElement.focus();
      } catch (e) {}
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('fab-drawer')) {
  customElements.define('fab-drawer', FabDrawer);
}

window.FabDrawer = FabDrawer;
